import { Paddle } from '@paddle/paddle-js';
import { AccountResponse } from '../../../shared/models/account/AccountResponse';
import { MonitorType } from '../../../shared/types/monitor/MonitorType';

export type MarketplaceAddon = 'EXPORT' | 'CLAUDE_WEB_SEARCH' | 'AGENCY' | 'ADDITIONAL_PROMPTS' | 'API';

/** What the billing webhook reads from the transaction to know what was bought. */
export type MarketplacePurchase =
  | { type: 'addon'; addonType: MarketplaceAddon }
  | { type: 'model'; monitorTypes: MonitorType[] };

/** Same checkout as `showCheckout` (PricingService) plus `customData` naming the purchase for the webhook. */
export const openMarketplaceCheckout = (
  paddle: Paddle,
  priceId: string,
  accountResponse: AccountResponse,
  purchase: MarketplacePurchase
): void => {
  paddle.Checkout.open({
    items: [{ priceId, quantity: 1 }],
    customer: {
      ...(accountResponse.addressId && { address: { id: accountResponse.addressId } }),
      ...(accountResponse.businessId && { business: { id: accountResponse.businessId } }),
      email: accountResponse.email,
    },
    ...(accountResponse.discountId && { discountId: accountResponse.discountId }),
    customData: { accountId: accountResponse.accountId, ...purchase },
    settings: {
      locale: accountResponse.language,
      displayMode: 'overlay',
      variant: 'one-page',
    },
  });
};
